
import router from "@/router";
import { logout } from "@/utils/logout";
import { defineComponent } from "@vue/runtime-core";
import { SettingOutlined } from "@ant-design/icons-vue";

export default defineComponent({
  components: {
    SettingOutlined,
  },
  methods: {
    logout,
    goToDashboard() {
      router.push("/dashboard");
    },
  },
});
